import React from 'react'

const SvgComponent = props => (
  <svg viewBox='0 0 216.17 206.51' {...props}>
    <defs />
    <g id='Layer_2' data-name='Layer 2'>
      <g id='Layer_1-2' data-name='Layer 1'>
        <path
          className='cls-1'
          d='M8.12 206.51h-8v-97.53L30.39 56.6 0 4l6.93-4 32.7 56.6-31.51 54.53v95.38z'
        />
        <path
          className='cls-1'
          transform='rotate(-45 31.592 174.914)'
          d='M27.59 135.14h8v79.56h-8z'
        />
        <path className='cls-1' d='M3.46 191.38h48.59v8H3.46z' />
        <path
          className='cls-1'
          d='M20.62 77.19h5v118.2h-5zM84.93 206.51h-8v-97.53L107.2 56.6 76.81 4l6.92-4 32.71 56.6-31.51 54.53v95.38z'
        />
        <path
          className='cls-1'
          transform='rotate(-45 108.4 174.91)'
          d='M104.4 135.14h8v79.56h-8z'
        />
        <path className='cls-1' d='M80.27 191.38h48.59v8H80.27z' />
        <path
          className='cls-1'
          d='M97.43 77.19h5v118.2h-5zM161.73 206.51h-8v-97.53l30.28-52.38L153.61 4l6.93-4 32.71 56.6-31.52 54.53v95.38z'
        />
        <path
          className='cls-1'
          transform='rotate(-45 185.203 174.916)'
          d='M181.21 135.14h8v79.56h-8z'
        />
        <path className='cls-1' d='M157.08 191.38h48.59v8h-48.59z' />
        <path className='cls-1' d='M174.23 77.19h5v118.2h-5z' />
      </g>
    </g>
  </svg>
)

export default SvgComponent



// WEBPACK FOOTER //
// ./src/components/UI/Icons/GiraffeIcon.js